import {fork} from 'redux-saga/effects'
import keepTokensValid from './keepTokensValid'

export default function* authRootSaga(): Generator {
  yield fork(keepTokensValid)
}



// WEBPACK FOOTER //
// ./src/auth/sagas/index.ts